import { render } from "./UsageExample.vue?vue&type=template&id=0a33b0f2"
import script from "./UsageExample.vue?vue&type=script&lang=js"
export * from "./UsageExample.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__